import WavesLogo from '../svg/common/waves-logo';

/**
 * Common forms logo.
 */
const FormLogo = () => {
    return (
        <div className="flex justify-center text-center mb-8">
            <WavesLogo width="50px" height="51" color="#231f20" />
        </div>
    )
};

export default FormLogo;